export type CatalogLabels = {
  vi?: string | null
  en?: string | null
  zh?: string | null
}

type LocalizedCatalogLabelOptions = {
  /** When locale is English, fall back to Vietnamese instead of English labels. */
  enFallback?: 'vi' | 'en'
}

export function localizedCatalogLabel(
  labels: CatalogLabels | undefined,
  locale: string,
  fallback?: string | null,
  options?: LocalizedCatalogLabelOptions,
): string {
  const normalized = locale.toLowerCase()
  const lang = normalized.startsWith('zh') ? 'zh' : normalized.startsWith('en') ? 'en' : 'vi'
  const enFallback = options?.enFallback ?? 'en'

  const value = (() => {
    if (lang === 'zh') return labels?.zh?.trim()
    if (lang === 'en') {
      if (enFallback === 'vi') return labels?.vi?.trim()
      return labels?.en?.trim()
    }
    return labels?.vi?.trim()
  })()

  if (value) return value

  const chain =
    enFallback === 'vi'
      ? [labels?.vi, labels?.zh, labels?.en, fallback]
      : [labels?.vi, labels?.en, labels?.zh, fallback]

  for (const candidate of chain) {
    const text = candidate?.trim()
    if (text) return text
  }

  return ''
}
